module.exports = __webpack_public_path__ + "img/aboutbanner1.b0b78feb.png";